const DATE_PICKER_BOTTOMSHEET = {
  dataAid: "availableDates",
  title: {
    text: "Select a date",
  },
  buttonTitle: {
    text: "Confirm",
  },
  subTag: {
    text:"of every month",
  },
};

const SELECT_SIP_DATE = {
  pageDataAid: "selectSipDate",
  header: {
    title: "Select SIP date",
    dataAid: "selectSipDate",
  },
  fund: {
    amount: {
      text: "SIP amount",
    },
    date: {
      text: "Monthly SIP date",
    },
    month: {
      text: "every month",
    },
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
  DATE_PICKER_BOTTOMSHEET,
};

export default SELECT_SIP_DATE;
